<template>
  <div class="blog-block blog-hero">
    <div class="blog-hero__date">
      <span v-html="data.date"></span>
    </div>
    <div class="blog-hero__title">
      <h1 v-html="data.title"></h1>
    </div>
    <div class="blog-hero__image" :style="{ backgroundImage: `url('${ data.image }')` }"></div>
  </div>
</template>

<script>
export default {
  name: 'BlogHero',

  props: ['data'],
};
</script>

<style lang="scss" scoped>
.blog-hero {
  &__date {
    font-size: rem(18px);
    font-size: calc(18px * var(--rw));
    margin-bottom: 30px;
  }

  &__title h1 {
    color: $color-black;
    font-weight: normal;
    font-size: rem(70px);
    font-size: calc(70px * var(--rw));
    line-height: rem(65px);
    line-height: calc(65px * var(--rw));

    @include mq($until: ipadL) {
      font-size: rem(50px);
      font-size: calc(50px * var(--rw));
      line-height: rem(55px);
      line-height: calc(55px * var(--rw));
    }
  }

  &__image {
    width: 100%;
    height: calc(600px * var(--rw));
    background-position: center center;
    background-size: cover;
    margin-top: 60px;
  }
}
</style>
